import { RegulationReviewPresentationMode } from './regulation-review-presentation-registry'

const REGULATION_REVIEW_PRESENTATION_STORAGE_KEY = 'research-review.regulations.presentation.v1'

const isKnownPresentationMode = mode => (
    mode === RegulationReviewPresentationMode.DETAILED
    || mode === RegulationReviewPresentationMode.COMPACT
)

const readRegulationReviewPresentationMode = () => {
    try {
        const storedMode = localStorage.getItem(REGULATION_REVIEW_PRESENTATION_STORAGE_KEY)

        return isKnownPresentationMode(storedMode)
            ? storedMode
            : RegulationReviewPresentationMode.DETAILED
    } catch (error) {
        return RegulationReviewPresentationMode.DETAILED
    }
}

const persistRegulationReviewPresentationMode = mode => {
    if (!isKnownPresentationMode(mode)) {
        return false
    }

    try {
        localStorage.setItem(REGULATION_REVIEW_PRESENTATION_STORAGE_KEY, mode)

        return true
    } catch (error) {
        return false
    }
}

export {
    REGULATION_REVIEW_PRESENTATION_STORAGE_KEY,
    isKnownPresentationMode,
    persistRegulationReviewPresentationMode,
    readRegulationReviewPresentationMode,
}
